<template>
  <div :class="[$attrs.class, {'tw-bg-orange-medium tw-text-white': option.isSelected}, {'hover:tw-text-orange-medium': !option.isSelected && !option.isDisabled}, {'tw-opacity-40': option.isDisabled}]" @click="handleClick" :data-option-id="option.id">
    <div class="tw-font-bold tw-flex">
      <span class="tw-flex-1 tw-text-center">
      {{option.name}} <span v-if="option.cost">(+{{option.cost.toFixed(2)}})</span>
      </span>
      <template v-if="props.optionQuantities && option.quantity">
        <div class="tw-grow-0 tw-mx-4 tw-flex tw-justify-center">
          <div class="tw-flex tw-justify-center tw-items-center">
            <button
              v-on:click.stop
              @click="decrementQuantity"
              class="tw-px-4 tw-text-2xl hover:tw-text-orange-300 tw-transition-all tw-font-bold tw-text-white">
              &mdash;
            </button>
            <label class="tw-mb-0">{{option.quantity}}</label>
            <button
              v-on:click.stop
              @click="incrementQuantity"
              class="tw-px-4 tw-text-3xl hover:tw-text-orange-300 tw-transition-all tw-font-bold tw-text-white">
              +
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, computed } from 'vue'
  import { useRouter } from 'vue-router'
  import type OptionInterface from '../../types/Option';

  const props = defineProps<{ 
    option: OptionInterface,
    optionQuantities: boolean,
    layoutType: String,
  }>();

  // const productImage = ref();

  const emit = defineEmits(['optionToggled', 'inverseToggled', 'quantityUp', 'quantityDown', 'resetOption'])
  const decrementQuantityBtn = ref();
  const incrementQuantityBtn = ref();

  // onMounted(() => {
  //   if (props.product != null && props.product.images) {
  //     let img = props.product.getImageByKey("product_category")

  //     if (img) {
  //       productImage.value = img.url
  //     } else {
  //       productImage.value = 'https://picsum.photos/400/400/?random'
  //     }
  //   }
  // })

  // const buttonPath = computed(() => {
  //   let path = "customize"
    
  //   if (props.product != null && props.product.metadata != null) {
  //     if (props.product.getMetaDataByKey("modifiable") != null && props.product.getMetaDataByKey("modifiable") == false) {
  //       path = "addToBag"
  //     } else if (props.product.getMetaDataByKey("buttonPath") && props.product.getMetaDataByKey("buttonPath") != "customize") {

  //     }
  //   }

  //   return path;
  // })

  const handleClick = () => {
    if (props.optionQuantities && props.option.quantity) {
      // Do nothing
    } else {
      if (props.option.inverseId != null && props.option.inverseId != undefined) {
        emit('inverseToggled', props.option)
        // props.option.isSelected = !props.option.isSelected;
      } else {
        emit('optionToggled', props.option)
        // props.option.isSelected = !props.option.isSelected;
      }
    }
  }

  const decrementQuantity = (() => {
    emit('quantityDown', props.option)
  })

  const incrementQuantity = (() => {
    emit('quantityUp', props.option)
  })

</script>
